import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';

@Component({
    selector: 'cm-delete-confirmation',
    templateUrl: './cm-delete-confirmation.component.html',
    styleUrls: ['./cm-delete-confirmation.component.scss'],
    standalone: false
})
export class CmDeleteConfirmationComponent {
	message: string;
	readonly locFeature: PortalCoreFeature;

	constructor(
		public dialogRef: MatDialogRef<CmDeleteConfirmationComponent>,
		@Inject(MAT_DIALOG_DATA) data,
		private settings: CmSettingsService
	) {
		this.message = data?.message ? data.message : null;
		this.locFeature = this.settings.portalCoreFeature;
	}
}
